<template>
    <div class="contentBox">
        <div class="goodsTop">
            <div class="searchTop">
                <div class="searchItem">
                     <el-select v-model="form.categoryUuid" clearable placeholder="商品分类">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                     </el-select>
                </div>
                 <div class="searchItem">
                    <el-button class="searchBtn" @click="search">搜索</el-button>
                    <el-button type="text" class="resetBtn" @click="resetData">
                        <i class="iconfont icon-qingchushujuku"></i>
                        <span>清除条件</span>
                    </el-button>
                </div>
            </div>
            <div class="searchRight" @click="handleManagement('add')">
                    <el-button type="primary" size="small">
                        <i class="el-icon-circle-plus-outline"></i>
                        添加
                    </el-button>
            </div>
        </div>
        <div class="tableList">
             <el-table
                :data="tableData"
                style="width: 100%"
                :cell-style="{textAlign:'center'}"
                :header-cell-style="{'text-align':'center','background':'rgba(242, 242, 242, 1)'}">
                <el-table-column
                    label="商品分类"
                    width="250"
                    prop="goodsRecommend">
                </el-table-column>
                <el-table-column
                    label="日期"
                    width="250"
                    prop="time">
                </el-table-column>
                <el-table-column
                    label="排序"
                    width="250"
                    prop="sort">
                </el-table-column>
                 <el-table-column
                    label="是否启用"
                    width="250"
                    prop="use">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleManagement('goods',scope.row)">推荐商品</el-button>
                        <el-button size="mini" type="text" v-if="scope.row.goodsRecommend != '人气推荐'" @click="handleManagement('modify',scope.row)">编辑</el-button>
                        <el-button type="text" v-if="scope.row.survival=='ENABLE'" @click="changeSurvival('DISABLE',scope.row.uuid)"
                                   size="small">停用
                        </el-button>
                        <el-button type="text" v-if="scope.row.survival=='DISABLE'" @click="changeSurvival('ENABLE',scope.row.uuid)"
                                   size="small">启用
                        </el-button>
                        <el-button size="mini" type="text" @click="sort(scope.row)">排序</el-button>
                        <el-button size="mini" type="text" v-if="scope.row.goodsRecommend != '人气推荐'" @click="deleteRow(scope.$index, scope.row.uuid)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>

        </div>
        <!-- 排序弹窗框 -->
        <el-dialog title="排序" :visible.sync="startDialogVisible" :close-on-click-modal="false">
            <el-form :model="form">
                <el-form-item label="排序">
                    <!-- <el-input v-model="form.name" autocomplete="off" style="width:200px"></el-input> -->
                    <el-input-number v-model="sortNum" :min="1"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="startDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="changeSort">确 定</el-button>
            </div>
            </el-dialog>
        <!-- 推荐商品 -->
        <recommendGoodsDialog ref="recommendGoodsDialogRef"></recommendGoodsDialog>
        <!-- 添加弹出框 -->
        <addDialog ref="addDialogRef"></addDialog>
        <!-- 修改弹出框 -->
        <modifyDialog ref="modifyDialogRef"></modifyDialog>
    </div>
</template>

<script>
import recommendGoodsDialog from './dialog/recommendGoodsDialog.vue'
import addDialog from './dialog/addDialog.vue'
import modifyDialog from './dialog/modifyDialog.vue'
import {getShopCategoryList, getRecommendCategoryList, modifyRecommendCategoryOrder, deleteRecommendCategory, modifyRecommendCategoryStatus} from "../../../utils/interface";
    export default {
        components: {
            recommendGoodsDialog,
            addDialog,
            modifyDialog,
            },
        data() {
            return {
                uuid:"",
                sortNum:null,
                vale:"",
                current:1,
                total: 0,
                pageSize: 8,
                classificationValue: '',
                startDialogVisible:false,
                options: [
                ],
                 tableData: [],
                form:{
                }
                }

            },
        created(){
            this.getCategoryList();
            this.search();
        },
        methods: {
            getCategoryList(){
                let params = {
                    parentUuid:"",
                    grade:"1",
                    type:'PLATFORM',
                    current:1,
                    pageSize:1000,
                }
                getShopCategoryList(params).then((res)=>{
                    this.options = [];
                    if (res != null && res.list != null && res.list.length > 0) {
                        res.list.forEach((item, index) => {
                            this.options.push({value:item.uuid,label:item.name});
                        });
                    }
                });
            },
            search(){
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                getRecommendCategoryList(this.form).then((res)=>{
                    this.tableData = [];
                    if(res != null && res.list != null && res.list.length > 0){
                        this.total = res.total;
                        res.list.forEach((item, index) => {
                            let recommend = {uuid:item.uuid,goodsRecommend:item.categoryName, goodsRecommendUuid:item.categoryUuid, time:item.createTime, sort: item.sort, use: item.survivalCn, survival:item.survival};
                            this.tableData.push(recommend);
                        });
                    }else{
                        this.total = 0;
                    }
                });
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.search();
            },
            resetData(){
                this.form.categoryUuid = null;
            },
           handleManagement(type,recommendClass){
                if(type == 'goods'){
                    this.$refs.recommendGoodsDialogRef.init(type, recommendClass)
                }
                if(type=="add"){
                     this.$refs.addDialogRef.init(type)
                }
                if(type=="modify"){
                     this.$refs.modifyDialogRef.init(type, recommendClass)
                }
            },
             //删除操作
            deleteRow(index,uuid){
                this.$confirm('确定删除当前数据?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteRecommendCategory(uuid).then((res) => {
                        if (res.success) {
                            this.$message.success('删除成功！');
                            this.tableData.splice(index, 1);
                        }else{
                            this.$message.error(res.message);
                        }
                    });

                }).catch(() => {
                });


            },
            //更改状态
            changeSurvival(val,uuid){
                let msg = "确定停用该商品分类的推荐吗?";
                if(val==='ENABLE'){
                    msg = "确定启用该商品分类的推荐吗?";
                }

                this.$confirm(msg, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    let params={uuid:uuid,survival:val}
                    return modifyRecommendCategoryStatus(params);
                }).then(() => {
                    this.$message.success("操作成功");
                    this.search();
                }).catch(function() {
                    this.$message.error("操作失败");
                });
            },
            sort(data){
                this.uuid = data.uuid;
                this.sortNum = data.sort;
                this.startDialogVisible=true;
            },
            //更改排序
            changeSort(){
                var numReg = /^[0-9]*$/
                var numRe = new RegExp(numReg)
                if (!numRe.test(this.sortNum)) {
                    this.$message({
                        type: 'warning',
                        message: '请输入数字',
                        duration: 10000,
                        showClose: true,
                    })
                    return false
                }
                if(this.uuid != ''){
                    let params={uuid:this.uuid,sort:this.sortNum}
                    modifyRecommendCategoryOrder(params).then((res) => {
                        if(res != null && res.success){
                            this.$message.success("操作成功");
                            this.startDialogVisible=false;
                            this.search();
                        } else{
                            this.$message.error(res.message);
                        }
                    });
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .contentBox {
        width: 97%;
        background-color: white;
        margin: auto;
        padding: 20px;
        box-sizing: border-box;
        height: 760px;

        .goodsTop {
            display: flex;
            justify-content: space-between;
            .searchRight {

            button {
                 width: 83px;
                height: 30px;
                background: rgba(21, 126, 251, 1);
                border: none;
                border-radius: 15px;
                font-size: 13px;
                margin-top: 5px;
                color: #fff;

                i {
                    padding-right: 5px;
                }

                &:hover {
                background: #61a2f0;
                   }
                }
            }
            .searchTop {
                display: flex;
                margin-bottom: 22px;
                .searchItem {
                    display: flex;
                    align-items: center;
                    margin-right: 30px;

                    .name {
                        min-width: 100px;
                    }
                }
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-range-editor {
                width: 500px;

                /deep/ .el-range-input {
                    width: 242px;
                    height: 32px;
                    min-height: 32px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                }

                /deep/ .el-range__icon,
                /deep/ .el-range-separator,
                /deep/ .el-range__close-icon {
                    line-height: 29px;
                }

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;

                    /deep/ .el-range-input {
                        background-color: #fff;
                    }
                }
            }

            .searchBtn {
                width: 82px;
                background-color: #3d7fff;
                border: none;
                color: white;
                font-size: 14px;
                border-radius: 15px;
            }

            .resetBtn {
                color: #000000;
            }
        }

       .tableList{
           .pagination{
               text-align: right;
                margin-top: 50px;

           }
       }

    }

</style>



// WEBPACK FOOTER //
// src/views/commodityManagement/category/category3DRecommend.vue